import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createCouplesDocument } from "../services/create-couples-document";
import { useToast } from "@/hooks/use-toast";

export function useCreateCouplesDocument() {
  const { toast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (bundleUsageId: string) => createCouplesDocument(bundleUsageId),
    onSuccess: (data) => {
      toast({
        title: "Success",
        description: "Couples therapy document created successfully",
      });
      // Open the document in a new tab
      window.open(data.documentUrl, '_blank');
      // Invalidate couples pack queries to refresh the data
      queryClient.invalidateQueries({ queryKey: ['couplesPacks'] });
    },
    onError: (error) => {
      toast({
        title: "Error",
        description: error.message || "Failed to create couples therapy document",
        variant: "destructive",
      });
    },
  });
}

